<div class="wrapper" *ngIf="survey">
     {{survey.PointSet.Datetime | date:'dd-MM-yyyy' }}
    <button *ngIf="AllowDelete" class="btn" (click)="DeleteSurvey(survey)" [disabled]="isDeleting">Verwijder</button>
</div>
